import { useEffect } from 'react';
import { axios } from '../api/apiClient';
import { AppError } from '../api/appError';
import { routes } from '../routes';
import { useNavigate } from 'react-router-dom';

const ignoredPaths = ['/tan/', '/files/'];

export const ApiClientConfig = ({ children }: { children: JSX.Element }): JSX.Element => {
  const navigate = useNavigate();

  useEffect(() => {
    axios.interceptors.response.use(
      res => {
        return res;
      },
      error => {
        const isUnauthorized = error?.response?.status === 401;
        const hadRequestAuthHeader = error?.config?.headers?.Authorization;
        const isCanceled = error?.response?.status === 412;

        if (isCanceled) {
          navigate(routes.linkExpired);
          throw error;
        }

        if (isUnauthorized && hadRequestAuthHeader) {
          console.error(error);
          navigate(routes.sessionTimeout);
          return;
        }
        for (const path of ignoredPaths) {
          if (error.config.url.startsWith(path)) {
            throw error;
          }
        }

        // API Error handling
        throw new AppError({
          errorCausingURL: window.location.pathname,
          errorCode: error?.response?.status ?? null,
          message: error.message
        });
      }
    );
  }, []);

  return children;
};
